import React from 'react';
import { toast } from 'react-toastify';
import { Load, DeleteItem, Success, SearchBar } from './partials/PopUps.js';
function ItemUser(props){
	return(
		<tr>
			<td className="tipo">{props.user.name}</td>
			<td className="email">{props.user.display_name}</td>
			<td className="email">{props.user.sucursal_name}</td>
			<td className="operaciones">
				<span className="icon-pencil" onClick={()=>props.editModal(props.user.id)}></span>
				<span className="icon-trash" onClick={()=>props.OpenModalDelete(props.user.id)}></span>
				<span className="icon-view" onClick={()=>props.openModalView(props.user.id)}></span>
			</td>
		</tr>
	)
}
function ItemSucursal(props){
	return (<option key={props.sucursal.id} value={props.sucursal.id}>{props.sucursal.nombre}</option>);
}
class Usuarios extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			users : [],
			usersDefault:[],
			action : '',
			search : '',
			display : { delete : false, load : false, success : false },
			modalAdd : false,
			modalEdit : false,
			modalView : false,
			sucursales :[],
			_currentUser : {},
			_copyCurrentUser : {},
		}
		this.static = {
			resetUser : {
				display_name: '',
				sucursal_name :'',
				email: '',
				id: 0,
				name: '',
				rol: '',
				sucursal_id: '',
				user_id: ''
			}
		}
	}
	componentDidMount = () =>{
		fetch(window.$api+'/usuarios')
		.then(res =>res.json())
		.then(
			(data)=>{
				return this.setState({ 
					users : data.users,
					usersDefault : JSON.parse( JSON.stringify(data.users)),
					sucursales : data.sucursales
				});
			},
			(error)=>{
				console.log( error );
			}
		)
	}
	openModalAdd = () =>{
		this.setState({modalAdd : !this.state.modalAdd});
	}
	openModalView = (id) =>{
		const _currentUser = this.state.users.find(e=>e.id===id);
		this.setState({modalView : !this.state.modalView, _currentUser});
	}
	searchHandler = (e) => {
		let search = e.target.value;
		let users = [];
		users = this.state.usersDefault.filter(user=>{
				const itemData = user.name.toUpperCase();
				const textData = search.toUpperCase();
				return itemData.indexOf(textData) > -1
		});
		this.setState({search,users});

	}
	editModal = (id) =>{
		const _currentUser = this.state.users.find(e=>e.id===id);
		const modalEdit = !this.state.modalEdit;
		this.setState({_currentUser, modalEdit});
	}
	saveUser = (e) => {
		e.preventDefault();
		if( this.state._currentUser.id ){
			const display = { load : !this.state.display.load}
			this.setState({display});
			const modalEdit = !this.state.modalEdit;
			const users = this.newObject(this.state.users);
			const _currentUser =  this.static.resetUser;
			
			let api = window.$api+'/usuarios/'+this.state._currentUser.id;
			let config = {
				method : 'PUT',
				body : JSON.stringify( this.state._currentUser ),
				headers : {
					'Content-Type': 'application/json'
				}
			};
			fetch(api,config).then(res=>res.json()).then(
				user=>{
					users.map(e=>{
						if( e.id === user.id ){
							e.display_name = user.display_name;
							e.email = user.email;
							e.id = user.id;
							e.name = user.name;
							e.rol = user.rol;
							e.sucursal_id = user.sucursal_id;
							e.sucursal_name = user.sucursal_name;
							e.user_id = user.user_id;
							return e;
						}else{
							return e;
						}
					});
					const display = { 
						load : !this.state.display.load,
					 	success : !this.state.display.success
					}
					toast.success('Registro actualizado con éxito');
					this.setState({users,_currentUser,modalEdit,display});
				},
				error=>{
					console.log(error);
				}
			);
		}else{
			if( Object.keys(this.state._currentUser).length !== 0 ){
				const display = { load : !this.state.display.load}
				this.setState({display});
				const modalAdd = !this.state.modalAdd;
				const users = this.newObject(this.state.users);
				let api = window.$api+'/usuarios';
				let config = {
					method : 'POST',
					body : JSON.stringify( this.state._currentUser ),
					headers : {
						'Content-Type': 'application/json'
					}
				};
				fetch(api,config).then(res=>res.json()).then(
					user=>{
						users.push(user);
						const display = { 
							load : !this.state.display.load,
							success : !this.state.display.success
						}
						const _currentUser = this.static.resetUser;
						toast.success('Registro actualizado con éxito');
						this.setState({users,_currentUser,modalAdd,display});
					},
					error=>{
						console.log(error);
					}
				);
			}else{
				toast.warning('Falta información');
			}
		}
	}
	OpenModalDelete = (id) =>{
		const _currentUser = this.state.users.find(e=>e.id===id);
		
		const display = { delete : !this.state.display.delete}
		
		this.setState({ display, _currentUser});
	}
	closeModalDelete = () =>{
		const display = { delete : !this.state.display.delete}
		this.setState({display});
	}
	deleteItem = () =>{
		const display = { load : !this.state.display.load};
		this.setState({display});
		const userid = this.state._currentUser.id;
		fetch(
			window.$api+'/usuarios/'+userid,
			{ method : 'DELETE' }
		).then(res=>res.json()).then(res=>{
			if( res.band === true ){
				const users = this.state.users.filter((item) => item.id !== userid);
				const action = 'success';
				const display = { 
					success : !this.state.display.success
				}
				const message = '¡Operación realizada con éxito!'
				this.setState({display,users,action,message});
			}else{
				const action = 'delete';
				const message = res.message;
				const display = { 
					success : !this.state.display.success
				}
				this.setState({display,action, message});
			}

		});
	}
	windowCloseUpdate = (action) => {
		if( action === 'delete'){
			const action = '';
			const display = { success : !this.state.display.success}
			this.setState({display,action});
		}else{
			const action = '';
			const display = { success : !this.state.display.success}
			this.setState({display,action});
		}
	}
	closeModalEdit = () =>{
		const modalEdit = !this.state.modalEdit;
		let _currentUser = this.static.resetUser;
		this.setState({modalEdit,_currentUser});
	}

	newObject = (obj) => {
		return JSON.parse( JSON.stringify( obj ) );
	}
	handlerInputEdit = (e) => {
		let text = e.target;
		let _currentUser = this.newObject( this.state._currentUser );
		if( text.name === 'rol' ){
			_currentUser[text.name] = text.value;
			_currentUser['display_name'] = ( text.value === "1" ? "Administrador" : "Vendedor" );
		}else{
			_currentUser[text.name] = text.value;
		}
		this.setState({_currentUser});
	}
	render = () =>{
		let listUsers = [];
		if( this.state.users.hasOwnProperty('length') && this.state.users.length > 0 ){
			this.state.users.forEach((u,index)=>{
				if( u.id !== undefined ){
					listUsers.push(
						<ItemUser
							key={u.id}
							user={u} 
							openModalView = {this.openModalView}
							editModal={this.editModal} 
							OpenModalDelete={this.OpenModalDelete}
						/>
					);
				}
			});
		}
	return(
		<div className="wrap-module">
			<h1>Usuarios</h1>
			<div className="wrap-content">
				<SearchBar searchHandler={this.searchHandler} openModal={this.openModalAdd} text={'usuario'}/>
				<table className='text-center'>
					<thead>
						<tr><td>Usuario</td><td>Tipo</td><td>Sucursal</td><td>Acciones</td></tr>
					</thead>
					<tbody key={1}>
						{ this.state.users.length > 0 ? listUsers : '' }
					</tbody>
				</table>
			</div>
			{ this.state.action !== '' &&
				<Success 
					display={this.state.display.success} 
					action={this.state.action}
					message={this.state.message}
					windowCloseUpdate={this.windowCloseUpdate} 
				/>
			}
			<DeleteItem 
				display={this.state.display.delete} 
				name={this.state.nombre} 
				closeModalDelete={this.closeModalDelete}
				deleteItem={this.deleteItem}
			/>
			{/* Nuevo */}
			<div className={this.state.modalAdd ? "overlay show" : "overlay"}>
				<form className="content" onSubmit={this.saveUser}>
					<div className="modal_header">
						<h5>NUEVO</h5>
						<span className="close-pop-up" onClick={()=>this.setState({ modalAdd : !this.state.modalAdd})}>x</span>
					</div>
					<div className="modal_body">
						<label>
							<input type="text" name="name" placeholder=" " 
								onChange={this.handlerInputEdit}
								value={this.state._currentUser.name||''}
							/>
							<span>Usuario</span>
						</label>
						<label>
							<input type="text" name="password" placeholder=" " 
								onChange={this.handlerInputEdit}
								value={this.state._currentUser.password||''}
							/>
							<span>Contraseña</span>
						</label>
						<label>
							<select 
							value={this.state._currentUser.hasOwnProperty('rol') && this.state._currentUser.rol}
							name="rol" onChange={this.handlerInputEdit}>
								<option> - </option>
								<option value="2">Vendedor</option>
								<option value="3">Secretaria</option>
								<option value="1">Administrador</option>
							</select>
							<span className="fixed">Rol</span>
						</label>
						<label>
							<select value={this.state._currentUser.hasOwnProperty('sucursal_id') ? this.state._currentUser.sucursal_id:'' }
							name="sucursal_id" onChange={this.handlerInputEdit}>
							<option> - </option>
							{
								this.state._currentUser.hasOwnProperty('rol') && 
								this.state.sucursales.map((e,indice)=>{
									return <ItemSucursal 
										key={indice}
										sucursal={e}
									/>
								})
							}
							</select>
							<span className="fixed">Sucursal</span>
						</label>
						<div className="text-center">
							<button type="submit" className="btn btn-green">Guardar</button>
							<div className="btn btn-green" onClick={()=>this.setState({ modalAdd : !this.state.modalAdd})}>Cancelar</div>
						</div>
					</div>
				</form>
			</div>
			<div className={this.state.modalEdit ? "overlay show" : "overlay"}>
				<form className="content" onSubmit={this.saveUser}>
					<div className="modal_header">
						<h5>EDITAR USUARIO</h5>
						<span className="close-pop-up" onClick={this.closeModalEdit}>x</span>
					</div>
					<div className="modal_body">
						<label>
							<input type="text" name="name" placeholder=" " 
								onChange={this.handlerInputEdit}
								value={this.state._currentUser.name||''}
							/>
							<span>Usuario</span>
						</label>
						<label>
							<input type="text" name="password" placeholder=" " 
								onChange={this.handlerInputEdit}
								value={this.state._currentUser.password||''}
							/>
							<span>Cambiar contraseña</span>
						</label>
						<label>
							<select 
							value={this.state._currentUser.hasOwnProperty('rol') && this.state._currentUser.rol}
							name="rol" onChange={this.handlerInputEdit}>
								<option> - </option>
								<option value="2">Vendedor</option>
								<option value="3">Secretaria</option>
								<option value="1">Administrador</option>
							</select>
							<span className="fixed">Rol</span>
						</label>
						<label>
							<select value={this.state._currentUser.hasOwnProperty('sucursal_id') ? this.state._currentUser.sucursal_id:'' }
							name="sucursal_id" onChange={this.handlerInputEdit}>
							<option> - </option>
							{
								this.state._currentUser.hasOwnProperty('rol') && 
								this.state.sucursales.map((e,indice)=>{
									return <ItemSucursal 
										key={indice}
										sucursal={e}
									/>
								})
							}
							</select>
							<span className="fixed">Sucursal</span>
						</label>
						<div className="text-center">
							<button type="submit" className="btn btn-green">Guardar</button>
							<div className="btn btn-green" onClick={this.closeModalEdit}>Cancelar</div>
						</div>
					</div>
				</form>
			</div>
			<Load display={this.state.display.load}/>
			<div className={this.state.modalView ? "overlay show" : "overlay"}>
				<div className="content" onSubmit={this.saveUser}>
					<div className="modal_header">
						<h5>DETALLES</h5>
						<span className="close-pop-up" onClick={()=>this.setState({modalView : !this.state.modalView })}>x</span>
					</div>
					<div className="modal_body">
						<p><strong>Nombre</strong> {this.state._currentUser.name}</p>
						<p><strong>Usuario: </strong> {this.state._currentUser.email}</p>
						<p><strong>Rol: </strong> {this.state._currentUser.display_name}</p>
						<p><strong>Sucursal</strong> {this.state._currentUser.sucursal_name}</p>
					</div>
				</div>
			</div>
		</div>
	)
}
}
export default Usuarios;